<section class="requests__filters">
  <form [formGroup]="formGroup" class="requests__form">
    <div class="requests__filter-search">
      <scc-dsm3-search-control
        [formGroup]="formGroup"
        formName="search"
        placeholder="CPE ou ID"
        (onApplySearch)="onValueChange()"
        (onEnter)="onValueChange()"
      ></scc-dsm3-search-control>
    </div>
    <div class="requests__filter-date">
      <scc-dsm3-date-picker-control-alt
        #date
        type="RANGE"
        placeholder="Data"
        [clearOnNewClick]="true"
        [closeOnClear]="true"
        formatDateOutput="yyyy-MM-dd"
        [control]="getInputFormDateControl"
        [formatWeekdayTitle]="'EEEEEE'"
        [canRangeSelectSameDate]="true"
        (onOpen)="onOpenDatepicker()"
        (onSelectedDate)="onValueChange()"
        (onClear)="onValueChange()"
      ></scc-dsm3-date-picker-control-alt>
    </div>
    <div class="requests__filter-status">
      <scc-dsm3-dropdown-control
        [formGroup]="formGroup"
        formName="status"
        [options$]="statusOptions$"
        placeholder="Estado"
        btnFilterLabel="Aplicar"
        (onOpen)="onOpenDropdowns()"
        (onApplyFilter)="onValueChange()"
        (onClear)="onValueChange()"
      >
      </scc-dsm3-dropdown-control>
    </div>
    <div class="requests__filter-category">
      <scc-dsm3-radio-dropdown-control
        #categories
        [formGroup]="formGroup"
        formName="category"
        [options$]="categoriesOptions$"
        placeholder="Categoria"
        btnFilterLabel="Aplicar"
        (onOpen)="onOpenDropdownRadioCategories()"
      >
      </scc-dsm3-radio-dropdown-control>
    </div>
    <div class="requests__filter-area">
      <scc-dsm3-radio-dropdown-control
        #areas
        [formGroup]="formGroup"
        formName="area"
        [options$]="areasOptions$"
        placeholder="Área"
        btnFilterLabel="Aplicar"
        (onOpen)="onOpenDropdownRadioAreas()"
      >
      </scc-dsm3-radio-dropdown-control>
    </div>
  </form>
</section>
